import { EventProperties } from "@segment/analytics-next";
import { useAnalytics } from "@/components/common/segment/AnalyticsContext";

/**
 * This hook is used to track events on public pages (Online Store, Client Portal, Booking Page)
 * If we want to use this hook, we should then disable page tracking on the page component (disablePageTracking = true)
 */
export const useTrackPublicPageEvents = <T extends string>(
  medspaId: string
) => {
  const analytics = useAnalytics();

  const trackEvent = (eventType: T, properties: EventProperties = {}) => {
    analytics.track(eventType, properties, {
      context: {
        groupId: medspaId,
      },
    });
  };

  return { trackEvent };
};
